.metricOptionsTooltip {
    text-align: left;
}